import type { BlueprintWithOrganizationData } from '@rtkwlf/track-public';

/**
 * Get organization favourite blueprints
 * @param blueprints
 * @returns BlueprintWithOrganizationData[], filtered blueprints
 */
export const getFavouriteBlueprints = (
  blueprints: BlueprintWithOrganizationData[],
) => {
  return blueprints.filter((blueprint) => blueprint.isFavourited);
};
